// extracted by mini-css-extract-plugin
export default {"Video":"_Video--P47rJ","VideoProcessingLink":"_VideoProcessingLink--zuh_j","ClockIcon":"_ClockIcon--gnuoJ"};